import { render, staticRenderFns } from "./LiveCourseLectures.vue?vue&type=template&id=36fa82a9&scoped=true"
import script from "./LiveCourseLectures.vue?vue&type=script&lang=ts"
export * from "./LiveCourseLectures.vue?vue&type=script&lang=ts"
import style0 from "./LiveCourseLectures.vue?vue&type=style&index=0&id=36fa82a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa82a9",
  null
  
)

export default component.exports